/* eslint-disable no-use-before-define */
import React from 'react'

export default ({color, label}) =>
    <React.Fragment>
    <svg height="10" width="10">
    <circle cx="5" cy="5" r="4" stroke={color} strokeWidth="1" fill={color} />
    </svg>
    &nbsp;
    {label}
    </React.Fragment>